<template>
    <div class="wrapper">

      <router-view></router-view>

      <!-- HeaderNavSix section -->
      <HeaderNav></HeaderNav>

        <div class="main-content">

            <!-- Breadcrumb section -->
            <HeroSectionFive ></HeroSectionFive>

            <div id="pGame" class="pricing-area pricing-style-4">
                <div class="container">
                    <div class="section-area">
                      <h2 class="section-title">Competizioni</h2>
                      <p class="section-desc mb-2">Segui il link, compila il form e diventa un protagonista dei questa edizione</p>
                      <p class="mb-2" style="font-weight: bold;">Per potersi iscrivere ad una prova a tempo è necessario che il mezzo sia prima registrato alla Best Truck (Area Raduno)</p>
                      <div class="banner-btn-wrap mt-5 mb-5">
                        <div class="banner-btn-wrap">
                                <a target=”_blank” href="https://competition.salentotruck.com/competition/register/1/truck/"  class="btn btn-custom-size blackberry-color extbot-primary-hover-4">Iscrizione Mezzi</a>
                                <a target=”_blank” href="https://competition.salentotruck.com/competition/register/1/competition" class="btn btn-custom-size blackberry-color extbot-primary-hover-4">Iscrizione Prove a tempo</a>
                              </div>
                      </div> 
                    </div>
                    
                    <div class="row">
                        <div class="col-12">
                            <div class="pricing-tab-content">
                                <div class="pricing-item-wrap row">
                                    <component :is="showWhich"></component>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>

        <!-- Footer section -->
        <FooterSectionFour class="space-top-140"></FooterSectionFour>

    </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNavST.vue'
import HeroSectionFive from '@/components/HeroSectionFive.vue'
import CompetitionCard from '@/pricing/CompetitionCard.vue'
import FooterSectionFour from '@/components/FooterSectionST.vue'
import MonthlyThree from '@/pricing/MonthlyThree.vue'
import YearlyThree from '@/pricing/YearlyThree.vue'


export default {
  components: {
    HeaderNav,
    HeroSectionFive,
    CompetitionCard,
    FooterSectionFour,
    MonthlyThree,
    YearlyThree
  },

  data () {
    return {
      showWhich: 'CompetitionCard'
    }
  }
}
</script>